import { TrainingApplyStatus } from "@bbj-types/apply/training";
import type { ChipProps } from "@mui/material";
import type { IGetTrainingAppliesByCandidate } from "@root/api/services/apply/training/getByCandidate";

export const TRAINING_APPLY_STATUS_FOLLOW_UP_LABELS: Record<TrainingApplyStatus, string> = {
  [TrainingApplyStatus.PROPOSED]: "Proposée au candidat",
  [TrainingApplyStatus.INTERESTED_CANDIDATE]: "Candidat intéressé",
  [TrainingApplyStatus.FORWARDED_RECRUITER]: "Transmise au recruteur",
  [TrainingApplyStatus.IN_PROGRESS_FILE]: "Complétion du dossier",
  [TrainingApplyStatus.REFUSED_STRUCTURE]: "Refus par la structure",
  [TrainingApplyStatus.REFUSED_CANDIDATE]: "Refus du candidat",
  [TrainingApplyStatus.INTEGRATED_CANDIDATE]: "Candidat intégré",
};

export const TRAINING_APPLY_STATUS_FOLLOW_UP_COLORS: Record<TrainingApplyStatus, ChipProps["color"]> = {
  [TrainingApplyStatus.PROPOSED]: "success",
  [TrainingApplyStatus.INTERESTED_CANDIDATE]: "success",
  [TrainingApplyStatus.FORWARDED_RECRUITER]: "success",
  [TrainingApplyStatus.IN_PROGRESS_FILE]: "success",
  [TrainingApplyStatus.REFUSED_STRUCTURE]: "error",
  [TrainingApplyStatus.REFUSED_CANDIDATE]: "error",
  [TrainingApplyStatus.INTEGRATED_CANDIDATE]: "success",
};

export const TRAINING_APPLY_STATUS_OPTIONS = Object.values(TrainingApplyStatus).map((value) => ({
  label: TRAINING_APPLY_STATUS_FOLLOW_UP_LABELS[value],
  color: TRAINING_APPLY_STATUS_FOLLOW_UP_COLORS[value],
  value,
}));

export const getTrainingApplyTooltip = (
  trainingApply: IGetTrainingAppliesByCandidate["data"][number],
  timeZone: string
) => {
  return `${TRAINING_APPLY_STATUS_FOLLOW_UP_LABELS[trainingApply.status]} le ${trainingApply.statusUpdatedAt.toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", timeZone })}`;
};
